export default __webpack_public_path__ + "static/media/DNo.11-0.dcbaa77d.jpg";